import React, { useState } from 'react';
import { Edit } from 'lucide-react';

const TemplateHeader = ({
  shortSummary,
  longSummary,
  isLoading,
  onRefresh,
  widgetSettings,
  onEditWidget
}) => {
  const [isHovering, setIsHovering] = useState(false);

  // Apply custom styles from settings
  const headerStyle = {
    backgroundColor: widgetSettings?.headerColor || '#ffffff',
    color: widgetSettings?.textColor || '#000000'
  };

  return (
    <div
      className="rounded-xl p-6 shadow-sm border border-gray-100 mx-auto animate-[fadeInUp_0.3s_ease-out] hover:shadow-md transition-shadow duration-200 relative"
      style={headerStyle}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      {isHovering && (
        <button
          onClick={onEditWidget}
          className="absolute top-3 right-3 p-2 bg-gray-100 hover:bg-gray-200 rounded-full transition-colors duration-200 z-10"
          title="Edit Widget Settings"
        >
          <Edit size={16} className="text-gray-600" />
        </button>
      )}

      <div className="flex flex-col">
        {isLoading ? (
          <div className="animate-pulse">
            <div className="h-4 bg-gray-200 rounded w-3/4 mb-4"></div>
            <div className="h-4 bg-gray-200 rounded w-full mb-2"></div>
            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
            <div className="h-4 bg-gray-200 rounded w-4/6"></div>
          </div>
        ) : (
          <>
            {shortSummary && (
              <h2 className="text-lg font-semibold mb-3" style={{ color: widgetSettings?.textColor || 'inherit' }}>
                {shortSummary}
              </h2>
            )}
            
            {longSummary && (
              <p className="text-base" style={{ color: widgetSettings?.textColor ? `${widgetSettings.textColor}CC` : 'inherit' }}>
                {longSummary}
              </p>
            )}
            
            {!shortSummary && !longSummary && (
              <p className="text-gray-500 italic">No summary available. Click refresh to generate a summary.</p>
            )}
          </>
        )}
      </div>

      {/* Optional refresh button */}
      {onRefresh && (
        <div className="mt-4">
          <button
            onClick={onRefresh}
            className="text-sm text-gray-500 hover:text-gray-700 flex items-center gap-1"
            disabled={isLoading}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
            {isLoading ? 'Refreshing...' : 'Refresh Summary'}
          </button>
        </div>
      )}
    </div>
  );
};

export default TemplateHeader;